<script setup lang="ts">
defineProps<{
  title: string
  smallDeviceOnly?: boolean
}>();

defineSlots<{
  default: () => unknown
}>();
</script>

<template>
  <div
    class="flex flex-col gap-m py-l border-b border-neutral-70"
    :class="{ 'lg:hidden': smallDeviceOnly }"
  >
    <IadTitle
      :text="title"
      variant="small-semibold"
    />
    <slot />
  </div>
</template>
